<template>
  <div class="room">
    <div class="room_header">
      <i class="el-icon-arrow-left" v-if="!searchInfo && !isScan" @click="goBack()"></i>
      <i class="el-icon-arrow-left" v-else-if="searchInfo" @click="btnFn"></i>
      <span v-else-if="model == 1 || model == 2">桌台:</span>
      <h2 v-if="model == 1 || model == 2">{{tabName}}</h2>
      <div class="search" :style="model == 0 || model == 3 ? 'margin-left: 10px' : ''">
        <el-input placeholder="名称，编号，拼音首字母" v-model="searchInfo"
        @focus="focus($event)" @input="searchFn()" @keyup.enter.native="searchFn()" class="input-with-select">
          <i slot="suffix" class="el-input__icon el-icon-search" @click="searchFn"></i>
        </el-input>
      </div>
    </div>

    <!-- 搜索的内容 -->
    <div class="search_content" v-if="searchInfo">
      <ul class="search_warp">
        <li class="search_list" v-for="(i, index) in searchList">
          <div class="li_list_img">
            <viewer :images="[{ url: imguri + '/foodimage/png/' + i.avator, title: i.remark }]">
              <img :src="imguri + '/foodimage/png/' + i.avator" alt="LOGO" v-if="i.avator" />
              <img src="../../../static/images/picture.png" alt="LOGO" v-else />
            </viewer>
          </div>
          <div v-if="i.surplus > 0" class="stock">剩余 {{(i.surplus*100 - i.num*100)/100}}</div>
          <div v-else-if="i.surplus == 0" class="stock_over">售罄</div>
          <div class="search_foodInfo">
            <h3><span v-if="i.discountType != 0 && i.originalPrice > i.finalPrice">[促]</span>{{i.name}}</h3>
            <div class="foodInfo_msg">
              <p>￥{{i.discountType != 0 ? i.finalPrice : i[priceName]}}</p>
              <span v-if="i.title">/{{i.title}}</span>
              <i v-if="i.originalPrice > i.finalPrice">￥{{i.originalPrice}}</i>
            </div>
            <div class="foodNum" v-if="i.isFormat && i.surplus != 0">
              <b v-show="i.num > 0">+{{i.num}}</b>
              <span @click="tasteShow(i)">选规格</span>
            </div>
            <div class="foodNum" v-else-if="i.isgroup == 1 && i.surplus != 0">
              <b v-show="i.num > 0">+{{i.num}}</b>
              <span @click="packageFn(i)">选套餐</span>
            </div>
            <div class="foodNum" v-else-if="i.isweigh == 1 && i.surplus != 0">
              <b v-show="i.num > 0">+{{i.num | capitalizetow}}</b>
              <span @click="weighFn(i)">填重量</span>
            </div>
            <div class="foodNum" v-else-if="i.surplus != 0">
              <img src="../../../static/images/minus.png" @click="numFn(i, -1)" />
              <p class="foodNum_num">
                <input type="number" v-model="i.num" placeholder="数量" @input="inputNumFn(i)" @focus="focus($event)" />
              </p>
              <img src="../../../static/images/plus.png" @click="numFn(i, 1)" />
              <div class="foodNum_note" v-if="i.startOrderQty > 1">起点数: {{i.startOrderQty}}</div>
            </div>
            <h4 class="foodInfo_note" v-if="i.isweigh == 1 && isScan">*称重菜品以实际重量为准</h4>
          </div>
        </li>
      </ul>
    </div>

    <div class="room_content" v-show="!searchInfo">
      <ul class="content_nav">
        <li v-for="(i, index) in foodsInfo" :class="{active:selectIndex==index}" @click="selectCategory(i, index)">
          <img :src="imguri + i.categoryIcon" alt="" v-if="i.categoryIcon" />
          <!-- <i class="el-icon-picture" v-else></i> -->
          <p style="display: inline;">{{i.foodCategory}}</p>
          <span v-if="i.num > 0 && index > 0 && i.foodCategory != '热门菜品'">{{i.num}}</span>
        </li>
      </ul>
      <div style="flex: 1;width: 70%;">
        <div class="names" v-if="subCategoryName.length>1">
          <div class="names_item " @click="selectCategorytow(f,index)" :class="indextos == index?'activeItem':''"
          v-for="(f,index) in subCategoryName" :key="index">{{f}}</div>
        </div>
        <ul class="content_tab" ref="contentRef">
          <li v-for="(i, index) in currFoosList" :class="i.names?'namels':''">
            <div class="nameSun" v-if="i.names" style="padding: 18px 0px 8px 4px; color: #F5711D; font-size: 14px;">
              <span v-if="i.foodCategory">{{i.foodCategory}}-</span>{{i.names}}
            </div>
            <!--  -->
            <div class="li_list_img" v-if="!i.names">
              <viewer :images="[{ url: imguri + '/foodimage/png/' + i.avator, title: i.remark }]">
                <img :src="imguri + '/foodimage/png/' + i.avator" alt="LOGO" v-if="i.avator" />
                <img src="../../../static/images/picture.png" alt="LOGO" v-else />
              </viewer>
            </div>
            <div v-if="i.surplus>0" class="stock">剩余 {{(i.surplus*100 - i.num*100)/100}}</div>
            <div v-else-if="i.surplus == 0" class="stock_over">售罄</div>
            <div class="foodInfo" v-if="!i.names">
              <h3><span v-if="i.discountType != 0 && i.originalPrice > i.finalPrice">[促]</span>{{i.name}}</h3>
              <div>
                <div class="foodInfo_msg">
                  <p>￥{{i.discountType != 0 ? i.finalPrice : i[priceName]}}</p>
                  <span v-if="i.title">/{{i.title}}</span>
                  <i v-if="i.originalPrice > i.finalPrice">￥{{i.originalPrice}}</i>
                </div>
                <div class="foodNum" v-if="i.isFormat && i.surplus!=0">
                  <b v-show="i.num > 0">+{{i.num}}</b>
                  <span @click="tasteShow(i)">选规格</span>
                </div>
                <div class="foodNum" v-else-if="i.isgroup == 1 && i.surplus != 0">
                  <b v-show="i.num > 0">+{{i.num}}</b>
                  <span @click="packageFn(i)">选套餐</span>
                </div>
                <div class="foodNum" v-else-if="i.isweigh == 1 && i.surplus != 0">
                  <b v-show="i.num > 0">+{{i.num | capitalizetow}}</b>
                  <span @click="weighFn(i)">填重量</span>
                </div>
                <div class="foodNum" v-else-if="i.surplus != 0">
                  <img src="../../../static/images/minus.png" @click="numFn(i, -1)" />
                  <p class="foodNum_num">
                    <input type="number" v-model="i.num" placeholder="数量" @input="inputNumFn(i)" @focus="focus($event)" />
                  </p>
                  <img src="../../../static/images/plus.png" @click="numFn(i, 1)" />
                  <div class="foodNum_note" v-if="i.startOrderQty > 1">起点数: {{i.startOrderQty}}</div>
                </div>
                <h4 class="foodInfo_note" v-if="i.isweigh == 1 && isScan">*称重菜品以实际重量为准</h4>
              </div>
            </div>
          </li>
          <div style="height: 50px;"></div>
        </ul>
      </div>
    </div>

    <div class="room_footer">
      <div class="footer_cart">
        <div @click="showCart=!showCart">
          <img src="../../../static/images/shopcart.png" alt="" />
          <span v-if="cartNum>0">{{cartNum | capitalizetow}}</span>
        </div>
        <h4>￥{{cartPrice}}</h4>
      </div>
      <p v-if="model == 3 && openid" class="submit" @click="showInfo">查看订单</p>
      <p v-if="(newCartList.length == 0 && oldCartList.length == 0) || !businessHours" @click="noteFn()">下一步</p>
      <p class="submit" @click="submitFn()" v-else>下一步</p>
    </div>

    <!-- 购物车 -->
    <div class="cart_bac" v-if="showCart" @click="showCart=false">
      <!--<div class="bac" @click="showCart=false"></div>-->
      <div class="cart_content" @click.stop>
        <div class="content_header clearFix">
          <p>购物车<i class="el-icon-edit-outline" @click="snapShowFn" v-if="!isScan">临时菜</i></p>
          <h6 @click="cartEmpty()">清空</h6>
        </div>
        <ul class="cart_list">
          <li class="cart_list_title" v-if="newCartList.length > 0">新点的菜</li>
          <li v-for="(i, index) in newCartList">
            <img :src="imguri + '/foodimage/png/' + (i.foodimage || 'LOGO.jpg')" alt="图片">
            <div class="cart_list_wrap">
              <div class="cart_list_data">
                <span v-if="i.otherStatus==1">[预点]</span>
                <span v-else-if="i.canteenStatus>=0">[{{statusList[i.canteenStatus].name}}]</span>
                <p>
                  <i>{{i.foodName}}</i>
                  <span v-if="i.givefoodnumber>0">[赠{{i.givefoodnumber}}]</span>
                  <span v-if="i.returnfoodnumber>0">[退{{i.returnfoodnumber}}]</span>
                </p>
              </div>
              <h5 class="cart_list_info" v-if="i.setMealItems && i.setMealItems.length > 0">
                <em v-if="i.setMealItems.length>0">(<span v-for="(j, index2) in i.setMealItems"> {{j.foodName}} </span>)</em>
                <em v-if="i.remark.length>0">
                  (<span v-for="(j, index2) in i.remark"> {{j.name}} </span>)
                </em>
              </h5>
              <h5 class="cart_list_info" v-if="i.remark.length > 0">
                (<span v-for="(j, index2) in i.remark"> {{j.name}} </span>)
              </h5>
              <div class="cart_list_info2">
                <p>￥{{i.allMoney}}<span>/{{i.unit}}</span></p>
                <h3 @click="getTaste(i, index)"><i class="el-icon-edit-outline"></i>口味</h3>
                <div class="cart_list_num">
                  <img v-show="!i.isDecimal" src="../../../static/images/minus.png" @click="cartFoodsNum(i, -1)" />
                  <p class="cart_numtow" v-if="i.isDecimal">
                    <input type="number" v-model="i.qty" placeholder="数量" @input="cartInputNumFn(i, index)" @focus="focus($event)" />
                  </p>
                  <p class="cart_num" v-if="!i.isDecimal">
                    <input type="number" v-model="i.qty" placeholder="数量" @input="cartInputNumFn(i, index)" @focus="focus($event)" />
                  </p>
                  <img v-show="!i.isDecimal" src="../../../static/images/plus.png" @click="cartFoodsNum(i, 1)" />
                </div>
              </div>
            </div>
          </li>

          <!-- 旧的菜 -->
          <li class="cart_list_title" v-if="oldCartList.length > 0">已点菜品</li>
          <li v-for="(i, index) in oldCartList">
            <img :src="imguri + '/foodimage/png/' + (i.foodimage || 'LOGO.jpg')" alt="图片">
            <div class="cart_list_wrap">
              <div class="cart_list_data">
                <span v-if="i.canteenStatus>=0">[{{statusList[i.canteenStatus].name}}]</span>
                <!--<i :style="i.returnfoodnumber == 1 ? 'color: red' : ''">{{i.foodName}}</i>-->
                <p>
                  <i>{{i.foodName}}</i>
                  <span style="color: red" v-if="i.givefoodnumber>0">[赠{{i.givefoodnumber}}]</span>
                  <span style="color: red" v-if="i.returnfoodnumber>0">[退{{i.returnfoodnumber}}]</span>
                </p>
              </div>
              <h5 class="cart_list_info" v-if="i.setMealItems && i.setMealItems.length > 0">
                (<span v-for="(j, index2) in i.setMealItems"> {{j.foodName}} </span>)
                <span v-if="i.remark">
                  (<span v-for="(j, index2) in i.remark"> {{j.name}} </span>)
                </span>
              </h5>
              <h5 class="cart_list_info" v-if="i.remark">(<span v-for="(j, index2) in i.remark"> {{j.name}} </span>)</h5>
              <div class="cart_list_info2">
                <p>￥{{i.allMoney}}<span>/{{i.unit}}</span></p>
                <div class="cart_list_num old_num">
                  <p>{{i.qty}}</p>
                </div>
              </div>
            </div>
          </li>
        </ul>
      </div>
    </div>

    <!-- 获取口味弹窗 -->
    <div class="taste_popUps" v-if="tasteFlag" @click="tasteFlag=false">
    	<div class="taste_content" @click.stop>
    		<h2  class="taste_title">
    			<span>选择口味</span>
    			<i class="el-icon-close" @click="tasteFlag=false"></i>
    		</h2>
    		<div class="taste_list">
    			<p v-for="(i, index) in tasteList" :class="{selectBor:i.isSelected}" @click="selectBtn(i)">
    				{{i.title}}
    				<span v-if="i.costFee>0"> +{{i.costFee}}</span>
    			</p>
    		</div>
    		<div class="taste_bottom">
    			<div class="taste_bottom_customize" v-if="!isScan">
    				<el-input v-model="tasteName" placeholder="口味名称" @focus="focus($event)" @keyup.enter.native="customizeTaste" clearable>
    					<el-button slot="append" @click="customizeTaste">确认</el-button>
    				</el-input>
    			</div>
    			<div class="taste_btn" :style="isScan ? 'flex: 1' : ''">
    				<el-button @click="determineTaste()">确定</el-button>
    			</div>
    		</div>
    	</div>
    </div>

    <!-- 规格弹窗 -->
    <div class="format" v-if="showTaste" @click="showTaste=false">
      <div class="format_content" @click.stop>
        <div class="format_header">
          <h2>{{tasteInfo.name}}</h2>
          <i class="el-icon-close" @click="showTaste=false"></i>
        </div>
        <ul class="format_List">
          <li v-if="tasteInfo.foodsize.length>0">
            <h3>规格<span>(必选-单选)</span></h3>
            <div class="format_info">
              <p v-for="(i, index) in tasteInfo.foodsize" :class="{formatSelect:i.isSelected}"
                @click="btnSelect(tasteInfo.foodsize, i, 'foodsize')">
                {{i.title}}
                <span v-if="i.weixin>0 && isScan">￥{{i.weixin}}</span>
                <span v-else-if="i.retailPrice>0 && !isScan">￥{{i.weixin || i.retailPrice}}</span>
              </p>
            </div>
          </li>
          <li v-if="tasteInfo.foodtasetEntity.length>0">
            <h3>
              {{tasteInfo.foodtasetEntity[0].typeName || '口味'}}
              <span v-html="tasteInfo.foodtasetEntity[0].noteTxt"></span>
            </h3>
            <div class="format_info">
              <p v-for="(i, index) in tasteInfo.foodtasetEntity" :class="{formatSelect:i.isSelected==true}"
                @click="btnSelect(tasteInfo.foodtasetEntity, i, 'foodtasetEntity')">
                {{i.name}}
                <span v-if="i.price>0">+{{i.price}}</span>
              </p>
            </div>
          </li>
          <li v-if="tasteInfo.foodSugarEntity.length>0">
            <h3>
              {{tasteInfo.foodSugarEntity[0].typeName || '糖度'}}
              <span v-html="tasteInfo.foodSugarEntity[0].noteTxt"></span>
            </h3>
            <div class="format_info">
              <p v-for="(i, index) in tasteInfo.foodSugarEntity" :class="{formatSelect:i.isSelected==true}"
                @click="btnSelect(tasteInfo.foodSugarEntity, i, 'foodSugarEntity')">
                {{i.name}}
                <span v-if="i.price>0">+{{i.price}}</span>
              </p>
            </div>
          </li>
          <li v-if="tasteInfo.foodTemperatureEntity.length>0">
            <h3>
              {{tasteInfo.foodTemperatureEntity[0].typeName || '温度'}}
              <span v-html="tasteInfo.foodTemperatureEntity[0].noteTxt"></span>
            </h3>
            <div class="format_info">
              <p v-for="(i, index) in tasteInfo.foodTemperatureEntity" :class="{formatSelect:i.isSelected==true}"
                @click="btnSelect(tasteInfo.foodTemperatureEntity, i, 'foodTemperatureEntity')">
                {{i.name}}
                <span v-if="i.price>0">+{{i.price}}</span>
              </p>
            </div>
          </li>
          <li v-if="tasteInfo.foodTopEntity.length>0">
            <h3>
              {{tasteInfo.foodTopEntity[0].typeName || '顶料'}}
              <span v-html="tasteInfo.foodTopEntity[0].noteTxt"></span>
            </h3>
            <div class="format_info">
              <p v-for="(i, index) in tasteInfo.foodTopEntity" :class="{formatSelect:i.isSelected==true}"
                @click="btnSelect(tasteInfo.foodTopEntity, i, 'foodTopEntity')">
                {{i.name}}
                <span v-if="i.price>0">+{{i.price}}</span>
              </p>
            </div>
          </li>
          <li v-if="tasteInfo.foodAddEntity.length>0">
            <h3>
              {{tasteInfo.foodAddEntity[0].typeName|| '加料'}}
              <span v-html="tasteInfo.foodAddEntity[0].noteTxt"></span>
            </h3>
            <div class="format_info">
              <p v-for="(i, index) in tasteInfo.foodAddEntity" :class="{formatSelect:i.isSelected==true}"
                @click="btnSelect(tasteInfo.foodAddEntity, i, 'foodAddEntity')">
                {{i.name}}
                <span v-if="i.price>0">+{{i.price}}</span>
              </p>
            </div>
          </li>
          <li v-if="tasteInfo.foodOtherEntity.length>0">
            <h3>
              {{tasteInfo.foodOtherEntity[0].typeName || '其他'}}
              <span v-html="tasteInfo.foodOtherEntity[0].noteTxt"></span>
            </h3>
            <div class="format_info">
              <p v-for="(i, index) in tasteInfo.foodOtherEntity" :class="{formatSelect:i.isSelected==true}"
                @click="btnSelect(tasteInfo.foodOtherEntity, i, 'foodOtherEntity')">
                {{i.name}}
                <span v-if="i.price>0">+{{i.price}}</span>
              </p>
            </div>
          </li>
        </ul>
        <div class="format_num">
          <h6>数量：</h6>
          <div class="format_num_opt">
            <img src="../../../static/images/minus.png" @click="formatNumFn(-1)"/>
            <p class="format_num_opt_qty">
              <input type="number" v-model="tasteInfo.num" placeholder="数量"
              @input="formatInputFn" @focus="focus($event)" />
            </p>
            <img src="../../../static/images/plus.png" @click="formatNumFn(1)"/>
            <div class="format_num_opt_note" v-if="tasteInfo.startOrderQty > 1">起点数: {{tasteInfo.startOrderQty}}</div>
          </div>
        </div>
        <div class="format_num" v-if="tasteInfo.iscurrentPrices == 1 && !isScan">
          <h6>价格：</h6>
          <div class="format_num_opt">
            <span style="line-height: 30px;">￥</span>
            <p class="format_num_opt_qty" style="width: 75px;">
              <input type="number" v-model="tasteInfo.allMoney" placeholder="价格" @focus="focus($event)" />
            </p>
            <span style="line-height: 30px;font-size: 14px;">/ {{tasteInfo.showTitle}}</span>
          </div>
        </div>
        <div class="format_footer">
          <h3 v-if="tasteInfo.iscurrentPrices != 1 || isScan">
            ￥{{tasteInfo.allMoney}}
            <i>/{{tasteInfo.showTitle}}</i>
            <!--<span>￥{{tasteInfo.retailPrice}}</span>-->
          </h3>
          <p @click="joinCart()">加入购物车</p>
        </div>
      </div>
    </div>

    <!-- 套菜弹窗 -->
    <div class="package" v-if="showPackage" @click="showPackage=false">
      <div class="package_content" @click.stop>
        <div class="package_header">
          <h2>套菜选择</h2>
          <i class="el-icon-close" @click="showPackage=false"></i>
        </div>

        <div class="package_body">
          <div class="package_body_item" v-for="(i, index) in packageList.list">
            <h4>{{i.foodName}}</h4>
            <div class="package_body_list clearFix">
              <div :class="{active2:k.isSelect}" v-for="(k, index2) in i.optionalFood" @click="packageSelectFn(i, k)">
                <h6>{{k.foodName}}</h6>
                <p>
                  <span v-if="k.increasePrice>0">+{{k.increasePrice}}</span>
                  <span>{{k.foodQty}}{{'/' + (k.unit || '份')}}</span>
                </p>
              </div>
            </div>
          </div>
        </div>

        <div class="format_num" v-if="packageInfo.iscurrentPrices == 1 && !isScan">
          <h6>总价：</h6>
          <div class="format_num_opt">
            <span style="line-height: 30px;">￥</span>
            <p class="format_num_opt_qty" style="width: 75px;">
              <input type="number" v-model="packageList.foodPrice" placeholder="总价" @focus="focus($event)" />
            </p>
          </div>
        </div>
        <div class="package_footer">
          <div class="package_footer_other">
            <div>
              <h6>套餐名称：</h6>
              <p>{{packageList.foodName}}</p>
            </div>
            <div>
              <h6 v-if="packageInfo.iscurrentPrices != 1">总价：</h6>
              <p v-if="packageInfo.iscurrentPrices != 1 || isScan">￥{{packageList.foodPrice}}</p>
            </div>
          </div>
          <div class="package_footer_confirm" @click="packageJoinCart()">确认</div>
          <!--<div class="package_footer_cancel">取消</div>-->
        </div>
      </div>
    </div>

    <!-- 临时菜弹窗 -->
    <div class="format" v-if="snapShow" @click="snapShow=false">
      <div class="format_content" @click.stop>
        <div class="format_header">
          <h2>新增临时菜</h2>
          <img src="../../../static/images/close_icon.png" alt="" @click="snapShow=false" />
        </div>
        <div class="format_item">
          <h6><span style="color: red;">*</span>名称：</h6>
          <p>
            <el-input placeholder="名称" v-model="snap.name" @focus="focus($event)"></el-input>
          </p>
        </div>
        <div class="format_item">
          <h6><span style="color: red;">*</span>价格：</h6>
          <p>
            <el-input type="number" placeholder="价格" v-model="snap.price" @focus="focus($event)"></el-input>
          </p>
        </div>
        <div class="format_item">
          <h6>类别：</h6>
          <p>
            <el-select v-model="snap.bigCategoryId" placeholder="请选择">
              <el-option v-for="i in categoryList" :key="i.id" :label="i.name" :value="i.id"></el-option>
            </el-select>
          </p>
        </div>
        <div class="format_item">
          <h6>区域：</h6>
          <p>
            <el-select v-model="snap.printArea" placeholder="请选择">
              <el-option v-for="i in areaList" :key="i.id" :label="i.printAreaName" :value="i.id"></el-option>
            </el-select>
          </p>
        </div>
        <div class="format_btn">
          <el-button size="small" @click="snapShow=false">取消</el-button>
          <el-button size="small" @click="snapConfirmFn">确认</el-button>
        </div>
      </div>
    </div>

    <!-- 扫码点餐输入数量弹窗 -->
    <div class="format" v-if="numShow">
      <div class="format_content" @click.stop>
        <div class="format_header">
          <h2>选择就餐人数</h2>
          <p @click="selectNum">选择</p>
        </div>
        <div class="format_content_num" @scroll="handlerScroll">
          <p :class="{active:i==mealsNumber}" v-for="(i, index) in 20" :key="index" @click="mealsNumber=i">{{i}}</p>
        </div>
      </div>
    </div>

    <!-- 填重量-改价格 -->
    <div class="currPrice" v-if="isEditPriceShow" @click="isEditPriceShow = false">
      <div class="currPrice-wrap" @click.stop>
        <h2>{{currInfo.name}}</h2>
        <div class="currPrice-content">
          <div class="currPrice-item">
            <h6>价格：</h6>
            <p>
              <el-input type="number" placeholder="价格" v-model="currInfo.currPrice"
              @focus="focus($event)" @input="inputFn"></el-input>
            </p>
          </div>
          <div class="currPrice-item">
            <h6>{{currInfo.currTitle}}：</h6>
            <p>
              <el-input type="number" :placeholder="currInfo.currTitle" v-model="currInfo.currNum"
              @focus="focus($event)" @input="inputFn"></el-input>
            </p>
          </div>
        </div>
        <div class="currPrice-btn" @click="currPriceFn">确认</div>
      </div>
    </div>
  </div>
</template>

<script>
  import qs from 'qs';
  import { interfaceFn, timeFn, isDuringDateFun } from '@/assets/util.js';
  import { wipeZero } from '@/assets/wipeZero.js';
  import VConsole from 'vconsole';
  export default {
    data() {
      return {
        name: 'Room',
        tabName: '', //当前的桌台名称
        foodsInfo: [], //菜品列表
        selectIndex: 0, //当前选中的大类
        currFoosList: [], //当前大类选中的菜品
        oldCartList: [], //已点的购物车菜品
        newCartList: [], //新点的购物车菜品
        cartPrice: 0, //购物车总价
        cartNum: 0, //购物车总数量
        showCart: false, //购物车隐藏显示
        showTaste: false, //规格隐藏显示
        showPackage: false, //套菜隐藏显示
        model: 0, // 点餐模式
        packageInfo: {},
        packageList: {
          list: [],
        }, //套餐
        tasteInfo: { //当前点击的规格info
          qty: 1,
          foodsize: [],
          foodtasetEntity: [],
          foodSugarEntity: [],
          foodTemperatureEntity: [],
          foodTopEntity: [],
          foodAddEntity: [],
          foodOtherEntity: []
        },
        searchInfo: '', //搜索的内容
        searchList: [], //搜索加载出来的内容
        isScan: false, //判断是否是扫码点餐
        priceName: 'finalPrice',// 扫码点餐：weixin，服务员点餐：finalPrice

        statusList: [{
          id: 0,
          name: '新品'
        }, {
          id: 1,
          name: '不厨打'
        }, {
          id: 2,
          name: '厨打'
        }, {
          id: 3,
          name: '等叫'
        }, {
          id: 4,
          name: '叫起'
        }, {
          id: 5,
          name: '催菜'
        }, {
          id: 6,
          name: '划菜'
        }, {
          id: 7,
          name: '退菜'
        }],
        imguri: interfaceFn(1),
        mealsNumber: 1, // 点餐人数
        numShow: false,
        isEditPriceShow: false,// 时价菜/称重菜 修改价格

        //临时菜
        categoryList: [], //新增临时菜需的分类
        areaList: [], //新增临时菜需的打印区域
        snapShow: false,
        snap: {
          name: '',
          price: '',
          bigCategoryId: '',
          printArea: ''
        },
        indexs: 0,
        indebox: 0,
        scopll: false,
        subCategoryName: [],
        indextos: 0,
        nameSun: '',
        scrollType: false,

        tasteFlag: false,//口味弹窗
        tasteName: '',//自定义口味名称
        tasteList: [],//系统口味列表信息
        currFoodId: '',//当前选口味的菜品id
        currFood: {
          currNum: 0,
          currPrice: 0,
        },//当前选口味的菜品
        currIndex: '',//当前选口味的菜品index
        currInfo: {},// 当前选的菜品
        businessHours: true,// 营业时段内
      }
    },
    created() {
      this.init(true);
    },
    mounted() {
      // 滚动触发函数
      let dom = document.getElementsByClassName('content_tab')[0];
      dom.addEventListener('scroll', this.scrollFn, false);
      /*css
      memberCode: "1001"
      passwordCode: "8888"
      shopCode: "100060"
      */
      // const vConsole = new VConsole();

      // let nums = this.wipeZeroFn(18.52);

      // 门店信息
      this.$http.get(interfaceFn() + '/shopService/get?shopId=' + localStorage.getItem('shopId')).then((res) => {
        if (res.data.returnCode == 'ok') {
          let result = res.data.result;
          if (result.orderActivatePay == 1) {
            this.$http.get(interfaceFn() + '/shopService/checkActivatePay?shopId='
            + localStorage.getItem('shopId')).then((msg) => {
              if (msg.data.returnCode != 'ok') {
                this.msgFn('warning', msg.data.message, 3000);
              }
            })
          }
        }
      })

    },
    filters: {
      // 过滤只保留小数点后两位,四舍五入
      capitalize: function(value) {
        if (!value) return 0;
        value = value.toFixed(3);
        return value;
      },
      // 不四舍五入，保留三位
      capitalizetow: function(value) {
        if (!value) return 0;
        value = Math.floor(Number(value) * 1000) / 1000;
        return value;
      }
    },
    methods: {
      /* 点击input选择状态 */
      focus(event) {
        event.currentTarget.select();
      },

      // 更新dom
      inputFn () {
        this.$forceUpdate();
      },

      /* 获取营业时间 */
      getshowTimeFn () {
      	var _this = this;
      	_this.$http.post('/shopService/shopTimePeriod', qs.stringify({
          merchantId: localStorage.getItem('merchantId'),
          shopId: localStorage.getItem('shopId')
        }), {
            headers: {"Content-Type": "application/x-www-form-urlencoded"}
        }).then((timeRes) => {
          if (timeRes.data.returnCode == 'ok') {
            var isShow = '';
            var list = timeRes.data.list;
            list.filter(f => {
              _this.showTimeMsg += f.beginTime + '-' + f.endTime + ' ';
              isShow += isDuringDateFun(f.beginTime, f.endTime) + ' ';
            });
            _this.businessHours = isShow.indexOf("true") != -1;
            if (list.length == 1 && list[0].beginTime == '00:00:00' && list[0].endTime == '23:59:59') {
              _this.businessHours = true;
            }

            // if (_this.businessHours == false) {
            //   alert(JSON.stringify(list));
            //   alert(isShow);
            // }
          }
        });
      },

      // 获取抹零设置
      // getWipe(){
      //   let _this = this;
      //   _this.$http.get(interfaceFn() + '').then((res)=>{

      //   })
      // },

      wipeZeroFn(totalAmount) {
        let erase = Number((totalAmount - wipeZero(totalAmount)).toFixed(2));
        return Number((totalAmount - erase).toFixed(2));
      },

      init(clearCart, selectNum) {
        var _this = this;
        var foodsInfo = {};
        if (clearCart) this.newCartList = JSON.parse(localStorage.getItem('newCartList') || '[]');
        localStorage.removeItem('externalId');
        let eatNum = localStorage.getItem('noteInfo')
        ? JSON.parse(localStorage.getItem('noteInfo')).eatNum : this.mealsNumber;
        var isScan = this.$store.state.isScan;
        var query = this.$route.query || {}; //连接参数
        _this.priceName = 'finalPrice';
        // ?sho=634&mer=600&tab=26268
        // ?mer=114&sho=160&tab=12034
        // ?mer=151&sho=227&tab=12481
        // ?mer=151&sho=519&tab=231007
        //扫码点餐模式提交订单后的返回
        if (isScan && !query.mer) query = _this.$store.state.scanInfo;
        if (query.mer && query.sho || isScan) { //扫码点餐模式
          _this.indebox = 1;
          _this.isScan = true;
          _this.$store.state.isScan = true;
          _this.priceName = 'weixin';
          _this.$store.state.scanInfo = query;
          if (query.fee) {
            localStorage.setItem('fee', query.fee);
          } else {
            localStorage.setItem('fee', 0);
          }
          let loadingInstance = _this.$loading({ fullscreen: true });
          _this.$http.get(interfaceFn() + '/getfoodbytable?mer=' + query.mer
          + '&sho=' + query.sho + '&tab=' + query.tab).then((res) => {
            loadingInstance.close();
            if (res.data.returnCode == "error") {
              this.$alert(res.data.message, '错误提示', {
                confirmButtonText: '确定',
                callback: action => {}
              });
              return;
            } else if (res.status == 200) {
              var data = res.data;
              _this.tabName = data.tablename;
              var orderInfo = data.order ? JSON.parse(data.order) : {
                orderInfo: {},
                orderItem: []
              };
              localStorage.setItem('cartInfo', JSON.stringify(orderInfo));
              var oldCartList = orderInfo.orderItem;
              if (data.order) localStorage.setItem('externalId', JSON.parse(data.order).externalId);
              oldCartList.filter(f => {
                if (f.remark) {
                  var remark = JSON.parse(f.remark);
                  var remarkList = [];
                  for (var i in remark) {
                    remarkList.push({
                      name: i,
                      price: remark[i]
                    })
                  }
                  f.remark = remarkList;
                }
              });

              foodsInfo = data.foodlist;
              foodsInfo.filter(f => {
                f.num = 0;
                f.subCategoryFoods.filter(h => {
                  h.filter(k => {
                    k.num = 0;
                    k.isFormat = false; // 增加字段，即是否存在选规格口味项
                    let len = k.foodAddEntity.length + k.foodSugarEntity.length + k.foodTemperatureEntity.length
                    + k.foodTopEntity.length + k.foodOtherEntity.length + k.foodsize.length + k.foodtasetEntity.length;
                    if (len > 0) {
                      k.foodsize.unshift({
                        barcode: k.barcode,
                        code: k.code,
                        cost: k.cost,
                        createTime: k.createTime,
                        foodId: k.foodId,
                        foodSizeId: k.id,
                        id: k.id,
                        merchantId: k.merchantId,
                        retailPrice: k.retailPrice,
                        shopId: k.shopId,
                        title: k.title,
                        updateTime: k.updateTime,
                        vipPrice: k.vipPrice,
                        weixin: (k.discountType != 0 ? k.finalPrice : k[_this.priceName])
                      });
                      k.isFormat = true;
                    }

                    // _this.newCartList.filter(n => {
                    //   if (n.foodId == k.id) {
                    //     k.num = Number(n.qty);
                    //     f.num += Number(n.qty);
                    //   }
                    // });
                  });
                })
              });
              var allFood = {
                foodCategory: '全部',
                num: 0,
                foods: []
              }

              //处理热门菜品显示
              foodsInfo.forEach((f, index) => {
                if (f.foodCategory == "热门菜品") {
                  f.subCategoryFoods = [f.foods];
                  f.subCategoryName.push("热门菜品");
                  f.subCategoryFoods.filter(h => {
                    h.filter(k => {
                      k.num = 0;
                      k.isFormat = false; // 增加字段，即是否存在选规格口味项
                      let len = k.foodAddEntity.length + k.foodSugarEntity.length + k.foodTemperatureEntity.length
                      + k.foodTopEntity.length + k.foodOtherEntity.length + k.foodsize.length + k.foodtasetEntity.length;
                      if (len > 0) {
                        k.foodsize.unshift({
                          barcode: k.barcode,
                          code: k.code,
                          cost: k.cost,
                          createTime: k.createTime,
                          foodId: k.foodId,
                          foodSizeId: k.id,
                          id: k.id,
                          merchantId: k.merchantId,
                          retailPrice: k.retailPrice,
                          shopId: k.shopId,
                          title: k.title,
                          updateTime: k.updateTime,
                          vipPrice: k.vipPrice,
                          weixin: (k.discountType != 0 ? k.finalPrice : k[_this.priceName])
                        });
                        k.isFormat = true;
                      }
                    });
                  })
                }
              })

              // 删除空分类
              foodsInfo.forEach((f, index) => {
                if (f.subCategoryFoods.length <= 0) {
                  foodsInfo.splice(index, 1);
                }
              })

              let listArr = [];
              foodsInfo.forEach((i, index) => {
                i.subCategoryFoods.forEach((f, indexs) => {
                  let temp = i.subCategoryName[indexs];
                  let temps = i.foodCategory;
                  let sumName = temps != temp ? temps : '';
                  f.unshift({
                    names: temp,
                    foodCategory: sumName
                  });
                  listArr.push(...f);
                })
              })


              allFood.foods = listArr;
              foodsInfo.unshift(allFood);

              //删除没使用的数据
              for (var i = 1; i < foodsInfo.length; i++) {
                foodsInfo[i].foods.length = 0;
                foodsInfo[i].subCategoryFoods.length = 0;
              }

              _this.foodsInfo = foodsInfo;

              // console.log(foodsInfo[0].foods);
              // return
              _this.currFoosList = foodsInfo[0].foods;
              _this.oldCartList = oldCartList;
              var oldPrice = oldCartList.map(i => Number(i.allMoney) * Number(i.qty)).reduce(((a, b) => a + b), 0);
              var newPrice = _this.newCartList.map(i => Number(i.allMoney) * Number(i.qty)).reduce(((a, b) => a + b), 0);
              _this.cartPrice = Math.floor(((oldPrice * 100 + newPrice * 100) / 100) * 100) / 100;
              _this.cartPrice = _this.cartPrice.toFixed(2);

              var oldNum = oldCartList.map(i => i.qty).reduce(((a, b) => a + b), 0);
              var newNum = _this.newCartList.map(i => i.qty).reduce(((a, b) => a + b), 0);
              _this.cartNum = ((oldNum * 100 + newNum * 100) / 100);
              _this.model = data.model;
              _this.openid = query.openid;

              localStorage.setItem('oldCartList', JSON.stringify(oldCartList));
              localStorage.setItem('shopId', query.sho);
              localStorage.setItem('merchantId', query.mer);
              localStorage.setItem('originaltableId', query.tab);
              localStorage.setItem('shopName', data.shopname);
              localStorage.setItem('model', data.model);
              localStorage.setItem('modelPay', data.modelPay);
              localStorage.setItem('cashPledge', 0); //押金
              localStorage.setItem('isGuest', 1); //判断是顾客1还是店员0
              localStorage.setItem('allPrices', _this.cartPrice);

              let judge = this.$route.query.judge;
              if (judge == 1) { //第二次进入不加载预点
                pageFn();
                return
              }

              // 获取门店桌台信息
              _this.$http.post(interfaceFn() + '/shopTable/tableMsg?shopId=' + localStorage.getItem('shopId')
              + '&tableId=' + localStorage.getItem('tableId')).then((msg) => {
                if (msg.data.returnCode == 'ok') {
                  let msgData = msg.data.tableMsg;
                  let curClickInfo = {
                    employeeId: 1,
                    mealsNumber: _this.mealsNumber,
                    id: localStorage.getItem('tableId'),
                    shopId: localStorage.getItem('shopId'),
                    title: data.tablename,
                    lowerCost: msgData[0] ? msgData[0].lowerCost : 0,
                    teaFee: 0,
                  };

                  localStorage.setItem('curClickInfo', JSON.stringify(curClickInfo));
                  let hasList = this.newCartList.filter(f => f.otherStatus == 1);
                  if (oldCartList.length == 0 && hasList.length == 0) {
                    if (_this.newCartList.length == 0 && !selectNum && _this.model != 3) _this.numShow = true;
                    getPreFn(true);
                  }
                }
              })
            }
          }).catch((err) => {
            loadingInstance.close();
            this.msgFn('error', '服务器错误，请稍后重试', 1000);
          });

          // 营业时段
          this.getshowTimeFn();
        } else { //服务员点餐模式
          this.indebox = 0;
          this.isScan = false;
          this.$store.state.isScan = false;
          let curClickInfo = JSON.parse(localStorage.getItem('curClickInfo')); //获取当前点击的桌台信息
          _this.tabName = curClickInfo.title;
          foodsInfo = JSON.parse(JSON.stringify(this.$store.state.foodsInfo)); //获取菜品列表

          var newCartList = JSON.parse(localStorage.getItem('newCartList')) || [];
          var payBack = localStorage.getItem('payBack');

          if (newCartList.length > 0 && payBack) {
            localStorage.removeItem('payBack');
            _this.newCartList = newCartList;
            _this.oldCartList = JSON.parse(localStorage.getItem('oldCartList')) || [];
            pageFn();
          } else {
            if (curClickInfo.status == 3) {
              //获取当前的已点的菜品信息
              _this.$http.get(interfaceFn() + '/getfoodOrder?sho=' + curClickInfo.shopId + '&tab=' + curClickInfo.id)
                .then((res) => {
                  if (res.data.order) {
                    var cartInfo = JSON.parse(res.data.order);
                    var oldCartList = cartInfo.orderItem;
                    localStorage.setItem('cashPledge', cartInfo.orderInfo.cashPledge);
                    localStorage.setItem('externalId', cartInfo.externalId);
                    localStorage.setItem('cartInfo', res.data.order);

                    //给选中大类小类添加数量
                    /*for (var i = 0; i < foodsInfo.length; i++) {
                    	for (var j = 0; j < foodsInfo[i].foods.length; j++) {
                    		var list = foodsInfo[i].foods[j];
                    		for (var k = 0; k < oldCartList.length; k++) {
                    			if (list.id == oldCartList[k].foodId) {
                    				//list.num = oldCartList[k].qty;
                    				//foodsInfo[i].num += list.num;
                    			}
                    			list.allMoney = list.weixin;//设置加上口味的价格
                    			if(oldCartList[k].remark && oldCartList[k].remark.length!=0 && oldCartList[k].remark!=[]){

                    				var remark = oldCartList[k].remark;
                    				//oldCartList[k].remark = JSON.parse(remark);
                    			}
                    		}
                    	}
                    }*/

                    let noList = oldCartList.filter(l => l.status == 0 && l.canteenStatus == 0);
                    let orderList = oldCartList.filter(l => l.status != 0 && l.canteenStatus != 0);
                    if (noList.length > 0) {
                      noList.filter(a => {
                        _this.newCartList.push({
                          id: a.id,
                          allMoney: a.allMoney,
                          foodId: a.foodId,
                          foodSizeId: a.foodSizeId,
                          foodName: a.foodName,
                          foodimage: a.foodimage,
                          time: a.createTime,
                          price: a.price,
                          qty: a.qty,
                          remark: a.remark || [],
                          unit: a.unit,
                          otherStatus: 2,
                          canteenStatus: a.canteenStatus,
                          setMealItems: a.setMealItems || []
                        })
                      })
                      oldCartList = orderList;
                    }
                    //转换remark格式
                    for (var k = 0; k < oldCartList.length; k++) {
                      let optSta = oldCartList[k].canteenStatus;
                      optSta == "undefined" || optSta == "null" || !optSta ? oldCartList[k].canteenStatus = 2 : '';
                      if (oldCartList[k].remark && oldCartList[k].remark.length != 0 && oldCartList[k].remark != []) {
                        var newArr = Array();
                        var remark = [];
                        if (oldCartList[k].remark) { // 有重复项判断
                          remark = oldCartList[k].remark.split('{').join('').split('}').join('').split('"').join('')
                            .split(',');
                        }
                        remark.filter(f => {
                          let arr = f.split(':');
                          newArr.push({
                            name: (arr.length > 2 ? arr[0] + ':' + arr[1] : arr[0]),
                            price: Number(arr[arr.length - 1])
                          })
                        });
                        // 无重复项判断
                        /*var remark = eval( '(' + oldCartList[k].remark + ')' );
                        //var remark = JSON.parse(oldCartList[k].remark);
                        for (let key in remark) {
                          	newArr.push({name: key,price: remark[key]});
                        }*/
                        oldCartList[k].remark = newArr;
                        continue;
                      }
                    }
                    localStorage.setItem('oldCartList', JSON.stringify(oldCartList));
                    _this.oldCartList = oldCartList;
                    pageFn();
                  }
                });
            } else if (curClickInfo.status == 0 && clearCart) { //未开台获取储存的点菜信息
              _this.$http.get(interfaceFn() + '/orderMessage/findInterimOrder?tableId=' + curClickInfo.id +
                '&shopId=' + curClickInfo.shopId).then((res) => {
                if (res.data.returnCode != "error") {
                  _this.newCartList = res.data.tableData.orderItem;
                  pageFn();
                } else {
                  let hasList = this.newCartList.filter(f => f.otherStatus == 1);
                  if (hasList.length == 0) getPreFn();
                }
              });
            }
          }
          _this.foodsInfo = foodsInfo;
          _this.currFoosList = foodsInfo[0].foods;
        }

        /* 页面数量的变化 扫码点餐*/
        function pageFntow() {
          foodsInfo.forEach(f => {
            f.foods.forEach(d => {
              _this.newCartList.forEach(k => {
                if (d.id == k.foodId) {
                  d.num = Number(k.qty);
                  f.num += Number(k.qty);
                }
              });
            });
          });
          let cartList = _this.newCartList.concat(_this.oldCartList);
          _this.cartPrice = cartList.map(i => (i.allMoney * i.qty)).reduce(((a, b) => a + b), 0); //购物车总价格
          _this.cartPrice = _this.cartPrice.toFixed(2);
          // _this.cartPrice = Math.floor(_this.cartPrice * 100) / 100
          // _this.cartPrice = (parseInt(_this.cartPrice*100)/100).toFixed(2);
          _this.cartNum = cartList.map(i => Number(i.qty)).reduce(((a, b) => a + b), 0); //购物车总数量
          _this.$forceUpdate();

          // 首页点击结算页面直接跳转
          if (localStorage.getItem('byTo') == 'pay') {
            localStorage.removeItem('byTo');
            _this.submitFn();
          }
        }

        /* 页面数量的变化 */
        function pageFn() {
          foodsInfo.forEach(f => {
            f.foods.forEach(d => {
              _this.newCartList.forEach(k => {
                if (d.id == k.foodId) {
                  d.num += Number(k.qty);
                  f.num += Number(k.qty);
                }
              });
            });
          });
          let cartList = _this.newCartList.concat(_this.oldCartList);
          _this.cartPrice = cartList.map(i => (Number(i.allMoney) * Number(i.qty))).reduce(((a, b) => a + b), 0); //购物车总价格
          _this.cartPrice = _this.cartPrice.toFixed(2);
          // _this.cartPrice = Math.floor(_this.cartPrice * 100) / 100
          // _this.cartPrice = (parseInt(_this.cartPrice*100)/100).toFixed(2);
          _this.cartNum = cartList.map(i => Number(i.qty)).reduce(((a, b) => a + b), 0); //购物车总数量
          _this.$forceUpdate();

          // 首页点击结算页面直接跳转
          if (localStorage.getItem('byTo') == 'pay') {
            localStorage.removeItem('byTo');
            _this.submitFn();
          }
        }

        //if (!clearCart) getPreFn();
        // 有桌台时的菜品预点
        function getPreFn(temp) {
          let curClickInfo = JSON.parse(localStorage.getItem('curClickInfo')); //获取当前点击的桌台信息
          _this.$http.get(interfaceFn() + '/orderMessage/tableMustOrder?number=' + eatNum + '&tableId=' + curClickInfo
            .id +
            '&shopId=' + curClickInfo.shopId).then((req) => {
            if (req.data.returnCode == 'ok') {
              let prePoint = req.data.list;
              prePoint.filter(n => {
                _this.newCartList.push({
                  allMoney: n.price,
                  canteenStatus: 2,
                  // createTime: n.createTime,
                  discount: 0,
                  foodId: n.foodId,
                  foodSizeId: 0,
                  foodName: n.foodName,
                  foodimage: n.foodImage,
                  price: n.price,
                  originalPrice: n.originalPrice || n.price,
                  givefoodnumber: 0,
                  returnfoodnumber: 0,
                  urgeNum: 0,
                  qty: n.qty,
                  unit: n.unit,
                  remark: [],
                  setMealItems: [],
                  status: 1,
                  otherStatus: 1,
                  prePointi: true,
                })
              });
              if (temp) {
                pageFntow();
              } else {
                pageFn();
              }
            }
          });
        }
      },

      // 扫码点餐选择人数
      selectNum() {
        this.numShow = false;
        localStorage.setItem('noteInfo', JSON.stringify({
          "eatNum": this.mealsNumber
        }));
        this.init(true, true);
      },

      /* 选择人数滚动事件 */
      handlerScroll(e) {
        let scroll = parseInt((e.srcElement.scrollTop) / 22);
        if (scroll <= 0) {
          this.mealsNumber = 1;
        } else {
          this.mealsNumber = scroll;
        }
      },

      btnFn() {
        this.searchInfo = '';
      },


      /* 触底操作 */
      scrollFn() {
        let _this = this;
        var viewHeight = window.innerHeight; //获取可视高度(屏幕高度)
        let scrollHeight = document.getElementsByClassName('content_tab')[0].scrollTop; //获取滚动的值
        let lengths = document.getElementsByClassName('namels').length;
        let topeHeight;
        let names, nametow, nameone;

        if (_this.indexs < lengths) { //边界
          topeHeight = document.getElementsByClassName('namels')[_this.indexs].offsetTop || '';
          if (viewHeight + scrollHeight > topeHeight + viewHeight) { //触顶
            names = document.getElementsByClassName('namels')[_this.indexs].firstChild.innerText;
            if (document.getElementsByClassName('nameSun')[_this.indexs].firstChild.innerText) { //大类不存在，存在小类时
              nameone = document.getElementsByClassName('nameSun')[_this.indexs].firstChild.innerText;
              nametow = nameone.replace("-", ""); //去除"-"
            }

            _this.indexs++;
            _this.foodsInfo.forEach((f, index) => {
              if (f.foodCategory == names || f.foodCategory == nametow) { //查询相同的name赋值下标
                _this.selectIndex = index;
                _this.nameSun = _this.foodsInfo[index].foodCategory;
                _this.subCategoryName = _this.foodsInfo[index].subCategoryName; //赋值小类
              }
            })

            // if(_this.subCategoryName.length>1){//切换小类
            //   _this.subCategoryName.forEach((i,index)=>{
            //     if(i == names){
            //         _this.indextos = index;
            //     }
            //   })
            // }
          }
        }

        if (document.getElementsByClassName('namels')[_this.indexs]) {
          let topeHeight2 = document.getElementsByClassName('namels')[_this.indexs].offsetTop;
          if (viewHeight + scrollHeight - 370 < topeHeight2) { //触底
            _this.indexs--;
            names = document.getElementsByClassName('namels')[_this.indexs].firstChild.innerText;

            if (document.getElementsByClassName('nameSun')[_this.indexs].firstChild.innerText) { //大类不存在，存在小类时
              nameone = document.getElementsByClassName('nameSun')[_this.indexs].firstChild.innerText;
              nametow = nameone.replace("-", ""); //去除"-"
            }
            _this.foodsInfo.forEach((f, index) => {
              if (f.foodCategory == names || f.foodCategory == nametow) { //查询相同的name赋值下标
                _this.selectIndex = index;
                _this.indextos = 0; //默认选中第一个小类
                _this.subCategoryName = _this.foodsInfo[index].subCategoryName; //赋值小类
                _this.nameSun = _this.foodsInfo[index].foodCategory;
              }
            })
          }
        }

        if (scrollHeight == 0 && _this.scrollType) { //到顶选中第一个
          document.getElementsByClassName('namels')[0].scrollIntoView(true);
          _this.selectIndex = 0;
          _this.indexs = 0;
          _this.subCategoryName = [];
          // this.msgFn('success', '已滑动到顶部！', 2000);
        } else {
          _this.scrollType = true;
        }
      },

      //返回上一页--- otherStatus预点菜品 1：这边给的，2PC端给的
      goBack() {
        var curClickInfo = JSON.parse(localStorage.getItem('curClickInfo')); //获取当前点击的桌台信息
        let prepareList = this.newCartList.filter(f => f.otherStatus == 1);
        if (curClickInfo.status == 0 && this.newCartList.length != prepareList.length) {
          this.$confirm('是否储存临时点菜信息', '提示', {
            distinguishCancelAndClose: true,
            confirmButtonText: '储存返回',
            cancelButtonText: '直接返回',
            type: 'info'
          }).then(() => {
            this.storeFn();
          }).catch((action) => {
            if (action === 'cancel') {
              this.tableOperate();
            }
          });
        } else {
          this.tableOperate();
        }
      },
      // 桌台操作解锁
      tableOperate() {
        let num = 1;
        var curClickInfo = JSON.parse(localStorage.getItem('curClickInfo')); //获取当前点击的桌台信息
        let cartInfo = localStorage.getItem('cartInfo');
        if (cartInfo) {
          cartInfo = JSON.parse(cartInfo);
          num = cartInfo.orderInfo.mealsNumber;
        }
        let info = {
          shopId: localStorage.getItem('shopId'),
          tableId: curClickInfo.id,
          userId: JSON.parse(localStorage.getItem('userInfo')).id,
          operate: 2, // 0：单纯开台不点餐，1：锁台，2：解锁,3:清台
          remark: '解锁',
          mealsNumber: num,
        }
        let loadingInstance = this.$loading({
          fullscreen: true
        });
        this.$http.post(interfaceFn() + '/shopTable/tableOperate',
          qs.stringify(info), {
            headers: {
              "Content-Type": "application/x-www-form-urlencoded"
            }
          }).then((res) => {
          loadingInstance.close();
          this.$router.push({
            path: "/home"
          });
        }).catch((err) => {
          loadingInstance.close();
          this.$router.push({
            path: "/home"
          });
        });
      },

      /* 储存信息 */
      storeFn() {
        var curClickInfo = JSON.parse(localStorage.getItem('curClickInfo')); //获取当前点击的桌台信息
        this.$http.post(interfaceFn() + '/orderMessage/saveInterimOrder', {
          "tableId": curClickInfo.id,
          "shopId": curClickInfo.shopId,
          "dinerNumber": curClickInfo.seatNum,
          "orderItem": this.newCartList
        }).then((res) => {
          this.tableOperate();
          if (res.data.returnCode == "ok") {
            this.msgFn('success', '储存成功', 1000);
          } else {
            this.msgFn('error', '储存失败', 1000);
          }
        })
      },

      /* 搜索 */
      searchFn() {
        if (!this.searchInfo) return;

        //加载菜品信息
        this.$http.get(interfaceFn() + '/merchantFood/getFoodDataByCode?shopId=' + localStorage.getItem('shopId') +
          '&nameOrCode=' + this.searchInfo + '&priceType=' + (this.isScan ? 1 : 0)).then((info) => {
          if (info.data.returnCode == 'ok') {
            var foodsList = info.data.list.foods;
            // if (foodsList.length == 0) {
            //   this.msgFn('warning', '暂无相关菜品', 1000);
            //   this.searchInfo = '';
            //   return;
            // }
            //增加num字段
            foodsList.filter(f => {
              f.num = 0;
              f.isFormat = false; // 增加字段，即是否存在选规格口味项
              let len = f.foodAddEntity.length + f.foodSugarEntity.length + f.foodTemperatureEntity.length +
                f.foodTopEntity.length + f.foodOtherEntity.length + f.foodsize.length + f.foodtasetEntity.length;
              if (len > 0) {
                f.foodsize.unshift({
                  barcode: f.barcode,
                  code: f.code,
                  cost: f.cost,
                  createTime: f.createTime,
                  foodId: f.foodId,
                  foodSizeId: f.id,
                  id: f.id,
                  merchantId: f.merchantId,
                  retailPrice: f.retailPrice,
                  shopId: f.shopId,
                  title: f.title,
                  updateTime: f.updateTime,
                  vipPrice: f.vipPrice,
                  weixin: f[this.priceName]
                });
                f.isFormat = true;
              }
            })

            if (this.newCartList.length > 0) {
              for (var i = 0; i < this.newCartList.length; i++) {
                for (var j = 0; j < foodsList.length; j++) {
                  if (this.newCartList[i].foodId == foodsList[j].id) {
                    foodsList[j].num += Number(this.newCartList[i].qty)
                  }
                }
              }
            }
            this.searchList = foodsList;
          }
        });
      },

      //切换tab页面
      selectCategory: function(info, index) {
        let list = document.getElementsByClassName('namels');
        let listArr = document.getElementsByClassName('nameSun');
        let type = true;
        let str, str_1;
        if (info.foodCategory == "全部") {
          document.getElementsByClassName('namels')[0].scrollIntoView(true);
          this.selectIndex = 0;
          this.indexs = 0;
          this.subCategoryName = [];
          return
        }

        if (info.foodCategory == "热门菜品") {
          document.getElementsByClassName('namels')[0].scrollIntoView(true);
          this.selectIndex = 1;
          this.indexs = 1;
          this.subCategoryName = [];
          return
        }

        for (let i = 0; i < list.length; i++) {
          str = list[i].firstChild.innerText.replace(/\s*/g, "");
          str_1 = info.subCategoryName[0].replace(/\s*/g, "");
          if (str == str_1) { //去除空格再对比
            document.getElementsByClassName('namels')[i].scrollIntoView(true);
            this.selectIndex = index;
            this.indexs = i;
            this.nameSun = info.foodCategory;
            this.subCategoryName = info.subCategoryName; //赋值小类
            this.indextos = 0; //默认选中第一个小类
            type = false;
          }
        }

        if (type) { //没找到大类
          let name, nametow;
          for (let i = 0; i < listArr.length; i++) {
            if (listArr[i].firstChild.innerText) {
              name = listArr[i].firstChild.innerText;
              nametow = name.replace("-", ""); //去除"-"
            }
            if (nametow == info.foodCategory) {
              document.getElementsByClassName('namels')[i].scrollIntoView(true);
              this.selectIndex = index;
              this.indexs = i;
              this.nameSun = info.foodCategory;
              this.subCategoryName = info.subCategoryName; //赋值小类
              this.indextos = 0; //默认选中第一个小类
              this.scrollType = false;
              return
            }
          }
        }
        this.scrollType = false;
      },

      // 小类切换
      selectCategorytow(f, index) {
        this.indextos = index;
        let list = document.getElementsByClassName('namels');
        let sumName = '';
        let str, str_1;
        for (let i = 0; i < list.length; i++) {
          if (list[i].firstChild.innerText == f) {
            sumName = f;
          } else {
            sumName = this.nameSun + '-' + f;
          }
          str = list[i].firstChild.innerText.replace(/\s*/g, "");
          str_1 = sumName.replace(/\s*/g, "");
          if (str == str_1) { //去除空格再对比
            document.getElementsByClassName('namels')[i].scrollIntoView(true);
            //强制刷新 vue
            this.$forceUpdate();
            return
          }
        }
      },

      /* 获取套菜 */
      packageFn: function(i) {
        /*if (i.surplus == i.num) {
        	this.msgFn('warning', '暂无更多库存', 1000);
        	return;
        }*/
        this.packageInfo = i;
        let loadingInstance = this.$loading({
          fullscreen: true
        });
        this.$http.get(interfaceFn() + '/selectSetMeal?foodId=' + i.id).then((res) => { //传的i.foodId改为i.id
          loadingInstance.close();
          if (res.data.returnCode == 'ok') {
            var data = res.data.setMealItemData;
            data.filter(f => f.optionalFood.filter((k, index) => index == 0 ? k.isSelect = true : k.isSelect = false));
            var n = 0;
            data.filter(f => {
              f.optionalFood.filter(i => {
                if (i.isSelect) n = ((n * 100 + i.increasePrice * 100) / 100).toFixed(2);
              })
            });
            this.packageList.list = data;
            this.packageList.foodName = i.name;
            this.packageList.foodPrice = ((i[this.priceName] * 100 + n * 100) / 100).toFixed(2);
            this.showPackage = true;
          } else {
            this.msgFn('warning', res.data.message, 1000);
          }
        }).catch(() => {
          loadingInstance.close();
          this.msgFn('error', '服务器错误，请稍后重试', 1000);
        });
      },
      /* 套菜选择 */
      packageSelectFn: function(i, k) {
        i.optionalFood.filter(f => f.isSelect = false);
        k.isSelect = true;
        var price = 0;
        this.packageList.list.filter(f => {
          f.optionalFood.filter(k => {
            if (k.isSelect) {
              price = ((k.increasePrice * 100 + price * 100) / 100).toFixed(2);
            }
          });
        });
        this.packageList.foodPrice = ((this.packageInfo[this.priceName] * 100 + price * 100) / 100).toFixed(2); //套菜加价
      },

      /* 套餐加入购物车 */
      packageJoinCart() {
        var packageInfo = this.packageInfo;
        var packageIds = [];
        var nums = 1;
        var data = JSON.parse(JSON.stringify(this.packageList));
        if(packageInfo.num == 0 && packageInfo.startOrderQty){
            nums = packageInfo.startOrderQty;
        }
        var info = {
          "allMoney": data.foodPrice,
          "canteenStatus": 2,
          "discount": 0,
          "foodimage": this.packageInfo.avator,
          "foodId": packageInfo.id,
          "foodSizeId": 0,
          "foodName": packageInfo.name,
          "qty": nums,
          "startOrderQty": packageInfo.startOrderQty,
          "price": data.foodPrice,
          "originalPrice": data.foodPrice,
          "givefoodnumber": 0,
          "returnfoodnumber": 0,
          "urgeNum": 0,
          "setMealItems": [],
          "remark": [],
          "unit": packageInfo.title || '份'
        };
        data.list.filter(f => {
          f.optionalFood.filter(k => {
            if (k.isSelect) {
              packageIds.push(k.foodId);
              info.setMealItems.push({
                "defaultItemPrice": k.defaultItemPrice || k.retailePrice,
                "foodId": k.foodId,
                "foodName": k.foodName,
                "foodQty": k.foodQty,
                "increasePrice": k.increasePrice,
                "unit": k.unit || '份'
              });
            }
          });
        });

        /* 改变页面数量 */
        var list = this.foodsInfo;
        // indebox
        for (var i = 0; i < list.length; i++) {
          for (var j = 0; j < list[i].foods.length; j++) {
            if (list[i].foods[j].id == packageInfo.id) {
              list[i].foods[j].num = Number(list[i].foods[j].num) + nums;
              list[i].num = Number(list[i].num) + nums;
            }
          }
        }

        // 搜索的num改变
        this.searchList.filter(f => {
          if (f.id == info.foodId) f.num += nums;
        })

        //加入購物車
        var cartList = this.newCartList.filter(f => f.foodId == info.foodId && f.price == info.price);
        if (cartList.length == 0) {
          this.newCartList.push(info);
        } else {
          var oldIdsList = [];
          cartList.filter(f => {
            var oldIdsArr = []
            f.setMealItems.filter(k => oldIdsArr.push(k.foodId));
            oldIdsList.push(oldIdsArr.join(','));
          });

          var m;
          oldIdsList.filter((f, index) => {
            if (f == packageIds.join(',')) {
              return m = index + '';
            }
            return;
          })
          if (m) {
            cartList[m].qty += 1;
          } else {
            this.newCartList.push(info);
          }
        }

        this.cartNum = Number(this.cartNum) + nums;
        this.allFn();
        this.showPackage = false;
      },

      // 填重量
      weighFn(i) {
        // if (i.surplus == i.num) {
        // 	this.msgFn('warning', '暂无更多库存', 1000);
        // 	return;
        // }

        // 时价菜填写价格
        this.currInfo = i;
        if (i.iscurrentPrices == 1 && !this.isScan) {
          let hasInfo = this.newCartList.filter(f => f.foodId == i.id);
          if (hasInfo.length > 0) {
            this.currInfo.currPrice = hasInfo[0].price;
            this.currInfo.currNum = hasInfo[0].qty;
          } else {
            this.currInfo.currPrice = i.finalPrice;
            this.currInfo.currNum = i.startOrderQty || 1;
          }
          this.currInfo.currTitle = '重量';
          this.isEditPriceShow = true;
          return;
        }
        this.$prompt('价格：￥' + i[this.priceName] + '/' + i.title, i.name, {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          inputPattern: /^(?!0(?:\.0+)?$)(?:[1-9]\d*|0)(?:\.\d{1,3})?$/,
          inputPlaceholder: '请输入重量',
          inputType: 'number',
          inputValue: 1,
          inputErrorMessage: '格式不正确，小数点限3位数'
        }).then(({ value }) => {
          /*if (value > i.surplus && i.surplus != 0) {
          	value = i.surplus;
          	this.msgFn('warning', '数量超过全部库存', 1500);
          }*/
          this.numFn(i, Number(value), true);
        }).catch(() => {});
      },
      // 重量改价
      currPriceFn () {
        this.isEditPriceShow = false;
        this.numFn(this.currInfo, Number(this.currInfo.currNum), true, Number(this.currInfo.currPrice), true);
      },

      // 页面input改数量
      inputNumFn(info) {
        if (Number(info.startOrderQty) >= Number(info.num)) info.num = Number(info.startOrderQty);
        /*if (info.num >= info.surplus) info.num = info.surplus;
        if (info.num < 0) info.num = 0;*/
        this.blurNumFn(info);
      },

      /* 页面失去焦点 */
      blurNumFn: function(info) {
        /*if (info.num.length >= 2) {
        	info.num = info.num.replace(/\b(0+)/gi, "");//去0
        }*/
        /*if (info.isFormat && info.surplus != 0) {
        	info.num = Math.ceil(info.num);
        } else {
        	info.num = Number(Number(info.num).toFixed(2));
        }*/
        info.num = Math.abs(info.num);
        info.num = Math.ceil(info.num);
        var isEmpty = this.newCartList.filter(f => f.foodId == info.id)[0] || {};
        if (!info.num || info.num <= 0) {
          info.num = 0;
          isEmpty.qty = 0;

          //移除num为0的菜品
          for (var i = 0; i < this.newCartList.length; i++) {
            if (this.newCartList[i].qty == 0) {
              this.newCartList.splice(i, 1);
            }
          }
        } else {
          if (isEmpty.foodId) {
            for (var i = 0; i < this.newCartList.length; i++) {
              if (this.newCartList[i].foodId == info.id) {
                this.newCartList[i].qty = info.num;
              }
            }
          } else {
            this.newCartList.push({
              'allMoney': info[this.priceName],
              'canteenStatus': 2,
              'discount': 0,
              'foodId': info.id,
              'foodSizeId': info.foodSizeId,
              'foodName': info.name,
              'foodimage': info.avator,
              'price': info[this.priceName],
              'originalPrice': info.originalPrice || info[this.priceName],
              'givefoodnumber': 0,
              'returnfoodnumber': 0,
              'urgeNum': 0,
              'qty': info.num,
              'remark': [],
              'setMealItems': [],
              'unit': info.title || '份',
            })
          }

          for (var i = 1; i < this.foodsInfo.length; i++) {
            for (var j = 0; j < this.foodsInfo[i].foods.length; j++) {
              if (this.foodsInfo[i].foods[j].id == info.id) {
                this.foodsInfo[i].foods[j].num = info.num;
                this.foodsInfo[i].num = this.foodsInfo[i].foods.map(i => Number(i.num)).reduce(((a, b) => a + b), 0);
              }
            }
          }
        }
        this.allFn();
      },

      // 页面--搜索数量+- userNum填重量的菜品使用输入的重量, 称重改价的金额，again时价菜再次调用
      numFn(obj, num, userNum, price, again) {
        let hasNum = userNum ? obj.num : 0;
        if (userNum) obj.num = 0;
        if (num == -1 && obj.num <= 0) return;
        if (num == -1 && obj.num < 1) obj.num = 1;
        if(obj.num == 0 && obj.startOrderQty && num < obj.startOrderQty){//起始数量
          num = obj.startOrderQty;
        }
        if (obj.num == obj.startOrderQty && num === -1) {
          num = -obj.startOrderQty;
        }
        if (obj.iscurrentPrices == 1 && !this.isScan && num > 0 && !again) {
          this.currInfo = obj;
          let hasInfo = this.newCartList.filter(f => f.foodId == obj.id);
          if (hasInfo.length > 0) {
            this.currInfo.currPrice = hasInfo[0].price;
            this.currInfo.currNum = hasInfo[0].qty;
          } else {
            this.currInfo.currPrice = obj.finalPrice;
            this.currInfo.currNum = obj.startOrderQty || 1;
          }
          this.currInfo.currTitle = '数量';
          this.isEditPriceShow = true;
          return;
        }
        /*if (num == 1 && obj.surplus == obj.num) {
        	this.msgFn('warning', '暂无更多库存', 1000);
        	return;
        }*/
        var list = this.foodsInfo,
          newCartList = [];

        /* 搜索出来的操作 */
        if (this.searchList.length > 0) {
          for (var i = 0; i < this.searchList.length; i++) {
            if (this.searchList[i].id == obj.id) {
              this.searchList[i].num = Number(this.searchList[i].num) + num;
            }
          }
        }

        /* 改变页面数量 indebox*/
        for (var i = 0; i < list.length; i++) {
          for (var j = 0; j < list[i].foods.length; j++) {
            if (list[i].foods[j].id == obj.id) {
              list[i].foods[j].num = Number(list[i].foods[j].num) + num;
              list[i].num = (Number(list[i].num) * 100 + Number(num) * 100 - Number(hasNum) * 100) / 100;
            }
          }
        }

        var info = {
          foodId: obj.id,
          foodSizeId: 0,
          canteenStatus: 2,
          discount: 0,
          foodName: "",
          foodimage: "",
          price: 0,
          givefoodnumber: 0,
          returnfoodnumber: 0,
          urgeNum: 0,
          qty: 1,
          startOrderQty: obj.startOrderQty,
          isweigh: obj.isweigh,
          unit: "",
          remark: [],
          setMealItems: [],
          allMoney: 0
        }
        info.foodId = obj.id;
        info.foodName = obj.name;
        info.foodimage = obj.avator;
        info.price = obj.discountType != 0 ? obj.finalPrice : obj[this.priceName];
        info.originalPrice = obj.originalPrice;
        info.qty = obj.num;
        info.unit = obj.title || '份';
        if (price > 0) info.price = price;
        info.allMoney = info.price;
        info.isDecimal = obj.isweigh == 1; // 记录称重商品

        //页面大类数量的变化
        /*for (var i = 0; i < this.foodsInfo.length; i++) {
			        for (var j = 0; j < this.foodsInfo[i].foods.length; j++) {
			          	if (this.foodsInfo[i].foods[j].id == info.foodId) {
			              	this.foodsInfo[i].foods[j].num += num;
			              	this.foodsInfo[i].num += num;
			            }
			        }
			    }*/

        if (this.newCartList.length > 0) {
          var foodData = this.newCartList.filter(f => f.foodId == info.foodId);
          if (userNum && foodData.length > 0) foodData[0].qty = 0;
          if (foodData.length == 1) {
            if (price > 0) {
              foodData[0].price = price;
              foodData[0].allMoney = price;
            }
            foodData[0].qty += num;
          } else {
            this.newCartList.push(info);
          }
        } else {
          this.newCartList.push(info);
        }
        //移除num小于等于0的菜品
        for (var i = 0; i < this.newCartList.length; i++) {
          if (this.newCartList[i].qty <= 0) {
            this.newCartList.splice(i, 1);
          }
        }
        this.allFn();
      },

      // 购物车修改规格菜品
      editMealFn (i, index) {
        let hasList = this.foodsInfo[0].foods.filter(f => f.id == i.foodId);
        if (hasList.length > 0) {
          let hasInfo = JSON.parse(JSON.stringify(hasList[0]));
          hasInfo.hasIndex = index;
          this.tasteShow(hasInfo, i);
        }
      },
      //显示口味弹窗
      getTaste (food, index) {
      	this.tasteFlag = true;
      	this.currFoodId = food.foodId;
      	this.currFood = food;
      	this.currIndex = index;
      	this.$http.get(interfaceFn()+'/merchantFood/getMerchantTaste?merchantId='
        + localStorage.getItem('merchantId')).then((res) => {
          if (res.data.returnCode == 'ok') {
            var info = res.data.tasteList;
            for (var i = 0; i < info.length; i++) {
              info[i].isSelected = false;

              //循环购物车的菜品，判断当前点击的菜品的口味是否是系统的口味
              for (var k = 0; k < food.remark.length; k++) {
                var remarkList = food.remark[k];
                if (remarkList.id == info[i].id) {// 增加id进行判断
                  info[i].isSelected = true;
                }
              }
            }
            let customize = food.remark.filter(f => f.id == 0);
            if (customize.length > 0) {
              customize.filter(f => {
                info.push(JSON.parse(JSON.stringify({
                  costFee: f.price,
                  id: 0,
                  isSelected: true,
                  merchantId: localStorage.getItem('merchantId'),
                  title: f.name
                })))
              })
            }
            this.tasteList = info;
          } else {
            this.msgFn (2000, res.data.message, 'error');
          }
        }).catch((err) => {});
      },
      //选中口味改变样式
      selectBtn (info) {
      	for (var i of this.tasteList) {
      		//i.isSelected = (i.id == info.id) && !i.isSelected;//可选中取消
      		if (i.id == info.id) {
      			i.isSelected = !i.isSelected
      		}
      	}
      },

      // 自定义口味
      customizeTaste () {
      	if (!this.tasteName) {
      		this.msgFn(2000, '请输入口味名称', 'warning');
      		return;
      	}
      	this.tasteList.push({
      		costFee: 0,
      		id: 0,
      		isSelected: true,
      		merchantId: localStorage.getItem('merchantId'),
      		title: this.tasteName
      	});
      	this.tasteName = '';
      },
      //口味选中确定按钮
      determineTaste () {
      	var selectSystemTaste = [];//选中的系统口味
      	this.tasteList.filter(f => {
      		if (f.isSelected == true) {
      			selectSystemTaste.push(f);
      		}
      	});

      	var oldPrice = 0;
      	if (this.currFood.remark) {
      		oldPrice = this.currFood.remark.map(t => t.price).reduce((a, b) => a + b, 0);
      	}

      	var newTaste = new Array();
      	// 获取选规格的口味
      	for (var t of (this.currFood.remark || [])) {
      		if (!t.system) {
      			newTaste.push(t);
      		}
      	}
      	// 选中的口味
      	selectSystemTaste.filter(f => {
      		newTaste.push({
      			name: f.title,
      			price: f.costFee,
      			id: f.id,
      			system: true
      		});
      	});

      	this.currFood.remark = newTaste;//设置当前点击的系统口味
      	var remarksPrice = newTaste.map(i => i.price).reduce(((a, b) => a + b), 0);//当前设置的系统口味的价格
        // 加上系统口味的价格
      	this.currFood.allMoney = ((this.currFood.allMoney * 100  + remarksPrice * 100 - oldPrice * 100)/100).toFixed(2);

      	this.newCartList[this.currIndex] = this.currFood;
      	this.tasteFlag = false;
        this.allFn();
      },

      //显示规格
      tasteShow: function(info, hasInfo) {
        info = JSON.parse(JSON.stringify(info));
        /*if (info.surplus == info.num) {
        	this.msgFn('warning', '暂无更多库存', 1000);
        	return;
        }*/
        this.showTaste = true;
        isSelected('foodAddEntity');
        isSelected('foodSugarEntity');
        isSelected('foodTemperatureEntity');
        isSelected('foodTopEntity');
        isSelected('foodOtherEntity');
        isSelected('foodtasetEntity');
        isSelected('foodsize');

        function isSelected(obj) {
          for (var item of info[obj]) {
            if (item != null || item != undefined) {
              item.isSelected = false;
            }
          }
          if (info[obj].length) {
            if (hasInfo) {
              // 购物车回显
              hasInfo.remark.filter(l => {
                for (var item of info[obj]) {
                  if (l.id == item.id && obj != 'foodsize') {
                    item.isSelected = true;
                  }
                  if (obj == 'foodsize' && item.title == hasInfo.unit) {
                    item.isSelected = true;
                  }
                }
              })

            } else {
              info[obj][0].isSelected = true; //默认选中第一个
            }

            if (obj != 'foodsize') {
              info[obj][0].noteTxt = '(' + (info[obj][0].isMust == 1 ? '必选' : '可选')
              + '-' + (info[obj][0].selectType == 0 ? '单选' : '多选') + ')';
            }
          }
        }

        let data = info['foodsize'];
        if (data.length > 0) { //对象去重，规格
          let newArr = this.unique(data, 'title');
          info['foodsize'] = newArr;
        }

        info.num = hasInfo ? hasInfo.qty : info.startOrderQty > 0 ? info.startOrderQty : 1;
        this.tasteInfo = info;
        this.selectPrice();
      },
      // 规格数量修改
      formatNumFn (num) {
        let qty = Number(num);
        if (Number(this.tasteInfo.startOrderQty) > Number(this.tasteInfo.num) && qty == -1) {
          qty = -this.tasteInfo.startOrderQty;
        } else if (Number(this.tasteInfo.startOrderQty) == Number(this.tasteInfo.num) && qty == -1) {
          qty = 0;
        }
        if (qty <= 0 && this.tasteInfo.num == 1) {
          this.tasteInfo.num = 1;
          return;
        }
        this.tasteInfo.num = Number(this.tasteInfo.num) + qty;
        this.$forceUpdate();
      },
      formatInputFn () {
        if (Number(this.tasteInfo.num) <= 0 || Number(this.tasteInfo.num) < Number(this.tasteInfo.startOrderQty)) {
          this.tasteInfo.num = this.tasteInfo.startOrderQty || 1;
        }
        this.$forceUpdate();
      },

      /* 去重 */
      unique(arr, key) {
        const obj = {}
        return arr.reduce((item, next) => {
          if (!obj[next[key]]) {
            obj[next[key]] = true;
            item.push(next);
          }
          return item
        }, [])
      },

      //选规格的口味选中按钮
      btnSelect: function(bigInfo, info, name) {
        let k = 0;
        for (var item of this.tasteInfo[name]) {
          if (item.isMust == 0 && item.selectType == 0 && item.id == info.id) { //不必选+单选
            item.isSelected = !item.isSelected;
          } else if (item.selectType == 0) {
            item.isSelected = (item.id == info.id);
          }
          if (item.isMust == 0 && item.selectType == 1 && item.id == info.id) { //不必选+多选
            item.isSelected = !item.isSelected;
          }
          if (name == 'foodsize') { //规格
            item.isSelected = (item.id == info.id);
          }
          if (item.isMust == 1 && item.selectType == 0 && item.id == info.id) { //必选+单选
            item.isSelected = (item.id == info.id);
          }

          if (item.isMust == 1 && item.selectType == 1 && item.id == info.id) { //必选+多选
            item.isSelected = !item.isSelected;
            this.tasteInfo[name].forEach((h, index) => {
              if (h.isSelected) {
                k++;
              }
            })
            if (k <= 0) {
              item.isSelected = (item.id == info.id);
            }
          }
        }
        this.selectPrice();
        this.$forceUpdate();
      },

      //加上口味的价格函数
      selectPrice() {
        var curFoodItem = this.tasteInfo; //当前点击的全部规格信息

        curFoodItem.showTitle = curFoodItem.foodsize.filter(f => f.isSelected)
        ? curFoodItem.foodsize.filter(f => f.isSelected)[0].title : '';
        var curWeixin = this.tasteInfo[this.priceName]; //当前点击的菜品价格
        var foodAddEntityPrice = getResult('foodAddEntity', 'price');
        var foodSugarEntityPrice = getResult('foodSugarEntity', 'price');
        var foodTemperatureEntityPrice = getResult('foodTemperatureEntity', 'price');
        var foodTopEntityPrice = getResult('foodTopEntity', 'price');
        var foodOtherEntityrPrice = getResult('foodOtherEntity', 'price');
        var foodsizePrice = getResult('foodsize', 'weixin') || (curFoodItem['foodsize'].filter(f => f.isSelected)[0].retailPrice * 100);
        var foodtasetEntityPrice = getResult('foodtasetEntity', 'price');
        var addCost = foodAddEntityPrice + foodSugarEntityPrice + foodTemperatureEntityPrice
        + foodTopEntityPrice + foodOtherEntityrPrice + foodtasetEntityPrice;
        var price = (addCost + foodsizePrice) / 100;

        function getResult(prop, valProp) {
          if (curFoodItem[prop].length > 0) {
            let sum = 0;
            // curFoodItem[prop].filter(t => t.isSelected)[0][valProp] * 100
            let data = curFoodItem[prop].filter(t => t.isSelected);
            if (data.length > 0) {
              data.forEach((f, index) => {
                sum += data[index][valProp] * 100;
              })
            } else {
              sum = 0;
            }
            return parseInt(sum);
          }
          return 0;
        }
        curFoodItem.addCost = addCost / 100;
        this.tasteInfo.allMoney = curFoodItem.foodsize[0] ? price : parseInt((price * 100) + (curWeixin * 100)) / 100;
      },

      // 选规格加入购物车
      joinCart: function() {
        let nums = Number(this.tasteInfo.num) || 1;//起始数量
        var info = {
          //addCost: 0,
          foodId: 0,
          foodSizeId: 0,
          canteenStatus: 2,
          discount: 0,
          foodName: "",
          foodimage: "",
          price: 0,
          originalPrice: 0,
          givefoodnumber: 0,
          returnfoodnumber: 0,
          startOrderQty: 1,
          urgeNum: 0,
          qty: 1,
          unit: "",
          remark: [],
          setMealItems: [],
          allMoney: 0
        }
        var infoCopy = new Object();
        for (var k of Object.keys(this.tasteInfo)) {
          infoCopy[k] = this.tasteInfo[k];
        }

        var foodAddEntity = selectList(infoCopy, 'foodAddEntity');
        infoCopy.foodAddEntity = foodAddEntity;
        var foodSugarEntity = selectList(infoCopy, 'foodSugarEntity');
        infoCopy.foodSugarEntity = foodSugarEntity;
        var foodTemperatureEntity = selectList(infoCopy, 'foodTemperatureEntity');
        infoCopy.foodTemperatureEntity = foodTemperatureEntity;
        var foodTopEntity = selectList(infoCopy, 'foodTopEntity');
        infoCopy.foodTopEntity = foodTopEntity;
        var foodOtherEntity = selectList(infoCopy, 'foodOtherEntity');
        infoCopy.foodOtherEntity = foodOtherEntity;
        var foodsize = selectList(infoCopy, 'foodsize');
        infoCopy.foodsize = foodsize;
        var foodtasetEntity = selectList(infoCopy, 'foodtasetEntity');
        infoCopy.foodtasetEntity = foodtasetEntity;

        //获取选中的口味信息
        function selectList(obj, child) {
          if (obj[child].length > 0) {
            return obj[child].filter(t => t.isSelected == true);
          }
          return [];
        }

        //获取选中的口味信息id
        function getAllIds(f) {
          var props = ['foodsize', 'foodAddEntity', 'foodSugarEntity', 'foodTemperatureEntity', 'foodTopEntity', 'foodtasetEntity', 'foodOtherEntity'];
          var strIds = [];
          for (var p of props) {
            if (f[p].length == 1) strIds.push(f[p][0]['id']);
          }
          return strIds.join(',');
        }

        //获取购物车的口味信息id
        function getAllIds2(f) {
          var strIds2 = f.foodId;
          for (var p of f.remark) {
            strIds2 += ',' + p.id;
          }
          return strIds2;
        }
        var curFoodIds = getAllIds(infoCopy);
        var foodItem = this.newCartList.filter(f => getAllIds2(f) == curFoodIds);
        if (foodItem.length == 1) {
          if (this.tasteInfo.hasIndex >= 0) {
            this.newCartList[this.tasteInfo.hasIndex].qty = this.tasteInfo.num;
          } else {
            foodItem[0].qty += 1;
            foodItem[0].price = this.tasteInfo.allMoney;
            foodItem[0].allMoney = this.tasteInfo.allMoney;
          }
        } else {
          //起始数量
          if(infoCopy.num == 0 && infoCopy.startOrderQty){
            nums = infoCopy.startOrderQty;
          }
          info.foodId = infoCopy.id;
          info.foodName = infoCopy.name;
          info.foodimage = infoCopy.avator;
          info.startOrderQty = infoCopy.startOrderQty;
          info.qty = nums;

          info.unit = infoCopy.foodsize[0] ? infoCopy.foodsize[0].title : infoCopy.title;
          info.price = infoCopy.foodsize[0] ? infoCopy.foodsize[0].weixin : infoCopy[this.priceName];
          info.originalPrice = info.price;
          info.foodSizeId = infoCopy.foodsize[0] ? infoCopy.foodsize[0].id : 0;
          //info.addCost = infoCopy.addCost;

          var foodAddEntity = selectFn(infoCopy.foodAddEntity);
          if (foodAddEntity) {
            foodAddEntity.forEach((f, index) => {
              empty(f);
            })
          }

          var foodSugarEntity = selectFn(infoCopy.foodSugarEntity);
          if (foodSugarEntity) {
            foodSugarEntity.forEach((f, index) => {
              empty(f);
            })
          }

          var foodTemperatureEntity = selectFn(infoCopy.foodTemperatureEntity);
          if (foodTemperatureEntity) {
            foodTemperatureEntity.forEach((f, index) => {
              empty(f);
            })
          }

          var foodTopEntity = selectFn(infoCopy.foodTopEntity);
          if (foodTopEntity) {
            foodTopEntity.forEach((f, index) => {
              empty(f);
            })
          }

          var foodtasetEntity = selectFn(infoCopy.foodtasetEntity);
          if (foodtasetEntity) {
            foodtasetEntity.forEach((f, index) => {
              empty(f);
            })
          }

          var foodOtherEntity = selectFn(infoCopy.foodOtherEntity);
          if (foodOtherEntity) {
            foodOtherEntity.forEach((f, index) => {
              empty(f);
            })
          }

          /*var foodsize = selectFn(infoCopy.foodsize, "weixin", "title");
          empty(foodsize);*/

          //去空数组
          function empty(obj) {
            if (obj) {
              return info.remark.push(obj);
            }
            return;
          }
          info.allMoney = this.tasteInfo.allMoney;
          if (this.tasteInfo.hasIndex >= 0) {
            this.newCartList[this.tasteInfo.hasIndex] = info;
          } else {
            this.newCartList.push(info);
          }
        }

        //获取当前选中的口味
        function selectFn(obj) {
          var result = [];
          if (obj.length > 0) {
            // result.name = obj.filter(t => t.id)[0].name;
            // 	result.price = obj.filter(t => t.id)[0].price;
            // 	result.id = obj.filter(t => t.id)[0].id;
            obj.forEach((f, index) => {
              let temp = {};
              temp.id = f.id;
              temp.price = f.price;
              temp.name = f.name;
              result.push(temp);
            })
            return result;
          }
          return;
        }

        // indebox
        /* for (var i = 0; i < this.foodsInfo.length; i++) {
          for (var j = 0; j < this.foodsInfo[i].foods.length; j++) {
            if (this.foodsInfo[i].foods[j].id == infoCopy.id) {
              this.foodsInfo[i].foods[j].num += nums;
              this.foodsInfo[i].num += nums;
            }
          }
        } */
        /* for (var i = 0; i < this.foodsInfo.length; i++) {
          this.foodsInfo[i].num = this.foodsInfo[i].foods.map(i => Number(i.num)).reduce(((a, b) => a + b), 0);
        } */

        // 页面数量修改
        for (var b = 0; b < this.foodsInfo.length; b++) {
          for (let a = 0; a < this.foodsInfo[b].foods.length; a++) {
            this.foodsInfo[b].foods[a].num = 0;
          }
        }
        for (var b = 0; b < this.foodsInfo.length; b++) {
          for (let a = 0; a < this.foodsInfo[b].foods.length; a++) {
            for (var r = 0; r < this.newCartList.length; r++) {
              if (this.foodsInfo[b].foods[a].id == this.newCartList[r].foodId) {
                this.foodsInfo[b].foods[a].num = (Number(this.foodsInfo[b].foods[a].num) * 100
                + Number(this.newCartList[r].qty) * 100) / 100;
              }
            }
          }
        }
        for (var b = 0; b < this.foodsInfo.length; b++) {
          this.foodsInfo[b].num = this.foodsInfo[b].foods.map(i => Number(i.num || 0)).reduce(((a, b) => a + b), 0);
        }

        // 搜索的num改变
        if (!info.id && foodItem.length > 0) info.foodId = foodItem[0].foodId;
        this.searchList.filter(f => f.num = 0);
        // this.searchList.filter(f => {
        //   if (f.id == info.foodId) f.num += nums;
        // })
        for (var b = 0; b < this.searchList.length; b++) {
          for (var r = 0; r < this.newCartList.length; r++) {
            if (this.searchList[b].id == this.newCartList[r].foodId) this.searchList[b].num += this.newCartList[r].qty;
          }
        }
        this.showTaste = false;
        // this.cartPrice = ((this.cartPrice * 100 + this.tasteInfo.allMoney * 100) / 100);
        // this.cartPrice = this.cartPrice.toFixed(2);
        // this.cartNum = Number(this.cartNum) + nums;
        this.allFn();

        // this.cartPrice = Math.floor(this.cartPrice * 100) / 100
        // this.cartPrice = (parseInt(this.cartPrice*100)/100).toFixed(2);
      },

      // 临时菜
      snapShowFn() {
        //this.showCart = false;
        this.snapShow = true;
        this.snap.name = '';
        this.snap.price = '';

        // 获取打印区域
        this.$http.get(interfaceFn() + '/merchantFood/getPrintArea?merchantId='
        + localStorage.getItem('merchantId')).then((res) => {
          if (res.data.returnCode == 'ok') {
            let data = res.data.result;
            this.areaList = data;
            this.snap.printArea = data[0].id;
          }
        });

        // 获取大类
        this.$http.get(interfaceFn() + '/merchantFood/getBigCategory?merchantId='
        + localStorage.getItem('merchantId')).then((res) => {
          if (res.data.returnCode == 'ok') {
            let data = res.data.result;
            this.categoryList = data;
            this.snap.bigCategoryId = data[0].id;
          }
        });
      },
      // 临时菜确认
      snapConfirmFn() {
        if (!this.snap.name) {
          this.msgFn("warning", "请输入名称！", 2000);
          return
        }
        if (!this.snap.price) {
          this.msgFn("warning", "请输入价格！", 2000);
          return
        }
        this.snapShow = false;
        let info = {
          "canteenStatus": 2,
          "discount": 0,
          "unitPrice": this.snap.price,
          "printArea": this.snap.printArea,
          "foodimage": "LOGO.jpg",
          "foodId": 0,
          "foodSizeId": 0,
          "allMoney": this.snap.price,
          "foodName": this.snap.name + '[临]',
          "unit": "份",
          "price": this.snap.price,
          "originalPrice": this.snap.price,
          "givefoodnumber": 0,
          "returnfoodnumber": 0,
          "urgeNum": 0,
          "qty": 1,
          "remark": [],
          "setMealItems": [],
          "bigCategoryId": this.snap.bigCategoryId,
        };
        this.newCartList.push(info);
        this.allFn();
      },


      //清空购物车
      cartEmpty() {
        this.showCart = false;
        var oldCartList = localStorage.getItem('oldCartList');
        localStorage.removeItem('newCartList');
        this.newCartList = [];
        this.selectIndex = 0;
        this.currFoosList = this.foodsInfo[0].foods;

        /*if (oldCartList) {
        	this.cartNum -= this.newCartList.map(i => Number(i.qty)).reduce(((a, b) => a + b), 0);
        	this.cartPrice = (((this.cartPrice * 100) - (this.newCartList.map(i => (Number(i.qty) * Number(i.price)))
        		.reduce(((a, b) => a + b), 0) * 100))/100).toFixed(2);
        } else {
        	this.showCart = false;
        	this.cartNum = 0;
        	this.cartPrice = 0;
        }*/

        for (var i = 0; i < this.foodsInfo.length; i++) {
          for (var j = 0; j < this.foodsInfo[i].foods.length; j++) {
            this.foodsInfo[i].foods[j].num = 0;
            this.foodsInfo[i].num = 0;
          }
        }
        this.searchList.filter(f => f.num = 0);
        this.allFn();
        //this.init(false);
      },

      // 购物车数量改变
      cartInputNumFn(info, index) {
        if (Number(info.startOrderQty) >= Number(info.qty)) info.qty = 0;
        /*if (info.qty < 0) {
        	info.qty = 1;
        }
        // 页面数量改变
        let allNum = this.newCartList.filter(f => f.foodId == info.foodId).map(i => Number(i.qty)).reduce(((a, b) => a + b), 0);
        for (var i = 0; i < this.foodsInfo.length; i++) {
        	for (var j = 0; j < this.foodsInfo[i].foods.length; j++) {
        		if (this.foodsInfo[i].foods[j].id == info.foodId) {
        			this.foodsInfo[i].foods[j].num = allNum;
        			if (this.foodsInfo[i].foods[j].num > this.foodsInfo[i].foods[j].surplus) {
        				this.foodsInfo[i].foods[j].num = this.foodsInfo[i].foods[j].surplus;
        				if (this.foodsInfo[i].foods[j].isFormat || this.foodsInfo[i].foods[j].isgroup == 1) {// 选规格--选套餐
        	    			let hasNum = (allNum * 100 - this.newCartList[index].qty * 100) / 100;
        	    			info.qty = (this.foodsInfo[i].foods[j].surplus * 100 - hasNum * 100) / 100;
        	    			return;
        				} else {
        					if (info.qty >= this.foodsInfo[i].foods[j].surplus) info.qty = this.foodsInfo[i].foods[j].surplus;
        				}
        			}
        		}
        	}
        }
        for (var i = 0; i < this.foodsInfo.length; i++) {
        	this.foodsInfo[i].num = this.foodsInfo[i].foods.map(i => Number(i.num)).reduce(((a, b) => a + b), 0);
        }*/
        this.cartBlurNumFn(info, index);
      },

      /* 购物车的数量失去焦点 */
      cartBlurNumFn(info, index) {
        info.qty = Math.abs(info.qty);
        if (info.isDecimal) {
          info.qty = Math.floor(Number(info.qty) * 1000) / 1000
        } else {
          info.qty = Math.ceil(info.qty);
        }
        if (info.qty == '') {
          info.qty == 1;
        } else {
          if (info.qty == 0) {
            /* 去除数量为0的菜品 */
            this.newCartList.splice(index, 1);
          }
        }

        /* 页面数量改变 */
        let allNum = this.newCartList.filter(f => f.foodId == info.foodId).map(i => Number(i.qty)).reduce(((a, b) => a + b), 0);
        for (var i = 0; i < this.foodsInfo.length; i++) {
          for (var j = 0; j < this.foodsInfo[i].foods.length; j++) {
            if (this.foodsInfo[i].foods[j].id == info.foodId) {
              this.foodsInfo[i].foods[j].num = allNum;
            }
          }
        }
        for (var i = 0; i < this.foodsInfo.length; i++) {
          this.foodsInfo[i].num = this.foodsInfo[i].foods.map(i => Number(i.num)).reduce(((a, b) => a + b), 0);
        }
        // 搜索数量变化
        for (var i = 0; i < this.searchList.length; i++) {
          if (this.searchList[i].id == info.foodId) this.searchList[i].num = allNum;
        }
        for (var i = 0; i < this.newCartList.length; i++) {
          if (this.newCartList[i].qty == 0) this.newCartList.splice(i, 1);
        }
        this.allFn();
        this.$forceUpdate();
      },

      // 购物车+-
      cartFoodsNum(info, num) {
        if (Number(info.startOrderQty) >= Number(info.qty) && num == -1) num = -info.startOrderQty;
        //if (num == -1 && info.qty < 1) return;
        /*if (num == 1) {
        	for (var i = 0; i < this.foodsInfo.length; i++) {
        		for (var j = 0; j < this.foodsInfo[i].foods.length; j++) {
        			if (this.foodsInfo[i].foods[j].surplus > 0) {
        				if (this.foodsInfo[i].foods[j].id == info.foodId
                && this.foodsInfo[i].foods[j].num >= this.foodsInfo[i].foods[j].surplus) {
        					this.msgFn('warning', '暂无更多库存', 1000);
        					return;
        				}
        			}
        		}
        	}
        }*/


        function getAllIds(f) {
          var strIds2 = f.foodId;
          for (var p of f.remark) { //cartPrice
            strIds2 += ',' + p.id;
          }
          return strIds2;
        }

        var foodItem = this.newCartList.filter(f => getAllIds(f) == getAllIds(info) && f.price == info.price);
        if (foodItem.length == 1) {
          foodItem[0].qty = Number(foodItem[0].qty) + num;
        }

        for (var i = 0; i < this.newCartList.length; i++) {
          if (this.newCartList[i].qty <= 0) {
            this.newCartList.splice(i, 1);
          }
        }

        //页面数量的变化 indebox
        for (var i = 0; i < this.foodsInfo.length; i++) {
          for (var j = 0; j < this.foodsInfo[i].foods.length; j++) {
            if (this.foodsInfo[i].foods[j].id == info.foodId) {
              this.foodsInfo[i].foods[j].num = Number(this.foodsInfo[i].foods[j].num) + num;
              this.foodsInfo[i].num = Number(this.foodsInfo[i].num) + num;
            }
          }
        }

        // 搜索数量变化
        for (var i = 0; i < this.searchList.length; i++) {
          if (this.searchList[i].id == info.foodId) this.searchList[i].num = info.qty;
        }
        this.allFn();

        if (num == -1 && this.newCartList <= 0) { //清除购物车，防止重量重复存在
          this.cartEmpty();
        }
        this.$forceUpdate();
      },

      // 查看订单
      showInfo() {
        if (!this.openid) return;
        this.$router.push({
          path: '/ticket'
        });
      },

      noteFn () {
        if (!this.businessHours) {
          this.msgFn('warning', '不在营业时间范围内！！', 1000);
        }
      },

      //订单提交按钮
      submitFn() {
        if (!this.businessHours) {
          this.noteFn();
          return;
        }
        let list = this.foodsInfo;
        for (var i = 0; i < list.length; i++) {
          for (var j = 0; j < list[i].foods.length; j++) {
            if (list[i].foods[j].surplus > 0 && list[i].foods[j].num > list[i].foods[j].surplus) {
              this.msgFn('warning', '【' + list[i].foods[j].name + '】最大可点数量为：' + list[i].foods[j].surplus, 1500);
              return;
            }
          }
        }

        localStorage.setItem('newCartList', JSON.stringify(this.newCartList)); //设置当前桌台状态的缓存
        localStorage.setItem('allFoodsMoney', this.cartPrice); //设置当前购物车的所有金额
        localStorage.setItem('payBack', false);
        setTimeout(() => {
          this.$router.push({ path: "/pay" });
        }, 50);
      },

      /* 计算数量与金额 */
      allFn() {
        let cartList = this.newCartList.concat(this.oldCartList);
        this.cartNum = cartList.map(i => Number(i.qty)).reduce(((a, b) => a + b), 0); //购物车总数
        let cartPrice = cartList.map(i => Number(i.qty) * Number(i.allMoney)).reduce(((a, b) => a + b), 0); //购物车总价
        // this.cartPrice = Math.floor(this.cartPrice * 100) / 100
        // this.cartPrice = (parseInt(this.cartPrice*100)/100).toFixed(2);
        this.cartPrice = cartPrice.toFixed(2);
      },

      // 提示
      msgFn(type, msg, time) {
        this.$Message({
          duration: time,
          message: msg,
          center: true,
          type: type
        });
      },
    },
  }
</script>
<style scoped>
  @import "../../../static/css/room.css";
</style>



// WEBPACK FOOTER //
// src/components/home/Room.vue